import React from 'react';
import { specialtyCoffeText } from './text';
import { Astyle } from './cssForComponents';
import StylishHeader from './stylishHeader';
import { generalStyleDivs  } from '../styles';
import { textInResolutionMobile, textInResolution } from '../multiFunctions';
import { Link } from 'react-router-dom';

function SpecialtyCoffeMain(props) {
     /* eslint-disable react/prop-types */
     let screenSize = {
        width: window.screen.width,
        height: window.screen.height
    }
    const isLargeScreen = props.isLargeScreen;
    const isSmallScreen = props.isSmallScreen;
    const textDimention = textInResolution("large", "x-large", "xxx-large", "xxx-large", screenSize);
    const textDimentionMobile = textInResolutionMobile("medium", "large", "large", screenSize);

    let textStyle = {
        fontSize: textDimention,
        paddingBottom: "10px"
    }
    let buttonStyle = {
        background: "rgb(226, 102, 14)",
        borderRadius: "30px",
        borderStyle: "solid",
        borderWidth: "2px",
        borderColor: "rgb(140, 110, 99)",
        color: "white",
        textTransform: "capitalize"
    }
    let buttonStyleDesktop = {       
        fontSize: textDimention,
        width: "90%",
        ...buttonStyle
    }
    let buttonStyleMobile = {
        width: "95%",
        height: "30px",
        fontSize: textDimentionMobile,
        ...buttonStyle
    }
    let styleImg = {
        margin: "10px",
        maxWidth: textInResolution("200px", "250px", "300px", "350px", screenSize),
    }
    return (
        <div>
            {isLargeScreen &&
                <div>
                    <StylishHeader headerText="Season Coffee"/>
                    <div style={{ display: "flex"}}>
                      
                       <div style={{ width: "70%",  margin: "10px", ...generalStyleDivs, display: "flex", flexFlow: "row" }}>
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: "center", margin: "10px" }}>
                                <img src="/img/specialtyCoffe.png" style={{ ...styleImg }}  alt=''/>
                            </div>
                            <div style={{ fontSize: props.fontSize, padding: "10px", display: 'flex', alignItems: 'center', lineHeight: "1.5" }}>
                                <Link to="/specialtyCoffee" style={{ display: "flex", justifyContent: "center", width: "100%", textDecoration: "none", color: "black",fontSize: props.fontSize }}>
                                    <span style={{ fontSize: props.fontSize  }} dangerouslySetInnerHTML={{ __html: specialtyCoffeText }}/>
                                </Link>
                            </div>
                       </div>
                       <div style={{ width: "30%", margin: "10px", ...generalStyleDivs, display: "flex", flexFlow: "column", justifyContent: "center", alignItems: "center" }}>
                            <span style={textStyle}>Peper</span>
                            <span style={textStyle}>Coffee</span>
                            <div style={{ width: "100%" }}>
                                <Link to="/specialtyCoffee" style={{ display: "flex", justifyContent: "center", width: "100%", textDecoration: "none" }}>
                                    <button style={buttonStyleDesktop}>info</button>
                                </Link>
                            </div>
                       </div>
                    </div>
                    
                </div>
            }
            {isSmallScreen &&
                <div>
                    <StylishHeader headerText="Season Coffee"/>
                    <a href='/specialtyCoffee' style={Astyle}>
                        <div style={{ display: "flex",  margin: "10px" }}>
                            <div style={{ width: "100%", height: "100%",
                                        display: "flex",
                                        flexDirection: "column",
                                        ...generalStyleDivs }}>
                                <div style={{  display: 'flex', justifyContent: 'center', alignItems: "cennter", margin: "10px" }}>
                                    <img src="/img/specialtyCoffe.png" width="100%" style={{ borderRadius: "30px", maxWidth: "300px", maxHeight: "300px" }} alt=''/>
                                </div>
                                <div style={{ padding: "10px", display: 'flex', alignItems: 'center' }}>
                                    <span dangerouslySetInnerHTML={{ __html: specialtyCoffeText }} />
                                </div>
                                <div style={{ display: "flex", alignItems: "center", fontSize: "xx-large", flexFlow: "column" }}>
                                    <span style={{ paddingBottom: "15px" }}>Pepper</span>
                                    <span style={{ paddingBottom: "15px" }}>Coffee</span>
                                </div>
                                <div style={{ display: "flex", justifyContent: "center", paddingBottom: "10px" }}>
                                    <button style={buttonStyleMobile}>info</button>
                                </div>
                            </div>
                        </div>
                    </a>
                </div>
            }
        </div>
    )
}
export default SpecialtyCoffeMain;